module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Celine-Wan-5a15fa64e253c3900873fca8a7b9ae62.jpg";